import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import DictionarySnippetsPage from './DictionarySnippetsPage'

import { useSharedDictionaryApprovalEnabled } from '@/hooks/useSharedDictionaryApprovalEnabled'
import { selectIsAdmin } from '@/store/features/user/userSlice'

// Exported, not inline in App.tsx: that module builds its router at load, so an inline guard
// cannot be rendered in isolation.
const DictionarySnippetsRoute = () => {
  const isAdmin = useSelector(selectIsAdmin)
  const enabled = useSharedDictionaryApprovalEnabled()

  // Admin first: a non-admin should not flicker while the flag resolves.
  if (!isAdmin) return <Navigate to="/app/home" replace />
  if (enabled === undefined) return null
  return enabled ? <DictionarySnippetsPage /> : <Navigate to="/app/home" replace />
}

export default DictionarySnippetsRoute
